export const baseUrl =
  window.location.hostname === "localhost"
    ? "http://localhost:4000"
    : window.location.origin;

const servers = {
  localhost: "http://localhost:3000",
};

export const baseClientUrl = servers[window.location.hostname];
